<div>
  <ion-text color="primary"><h2>{{translationKey + ".help_dialog.title" | translate}}</h2></ion-text>
  <ion-text [innerHTML]="translationKey + '.help_dialog.text'| translate"></ion-text>
  <ion-text color="primary"><h2>{{"IMAGE_PUZZLE.help_dialog.mechanics.play.title" | translate}}</h2></ion-text>
  <ion-text *ngIf="isMobile" [innerHTML]="'IMAGE_PUZZLE.help_dialog.mechanics.play.text.mobile'| translate"></ion-text>
  <ion-text *ngIf="!isMobile" [innerHTML]="'IMAGE_PUZZLE.help_dialog.mechanics.play.text.desktop'| translate"></ion-text>
</div>
